import SectionLayout from 'components/layouts/SectionLayout';
import React, { useEffect } from 'react';
import GHNextStepContent from './content/GHNextStepContent';
import PageLayout from 'components/layouts/PageLayout';
import SmallBanner from 'components/SmallBanner';

const GHNextStep = () => {

  useEffect(() => {
    // Change Tab Title
    document.title = "GH Next Step - Insurance Enterprise"
  }, [])

  return (
    <>
      <SmallBanner
        content={
          <>
            <SectionLayout content={
              <div className='text-3xl sm:text-4xl text-center font-bold'>Small Business & Groups Health Insurance Coverage</div>
            } />
          </>
        }
      />
      <PageLayout
        content={
          <>
            <SectionLayout content={<GHNextStepContent />} />
          </>
        }
      />
    </>
  );
}

export default GHNextStep;
